// extracted by mini-css-extract-plugin
export default {"container":"MoreDetails_container__KdD3C","card":"MoreDetails_card__7A4Cd"};